import { Component, OnInit } from '@angular/core';

@Component({
  selector: '[page-nub]',
  templateUrl: './page-nub.component.html',
  styleUrls: ['./page-nub.component.css']
})
export class PageNubComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
